import React from 'react'
import './Pivot.css'

function Woodshop_Pivot() {
  return (
    <div>
      <div className="coming-soon-container">
        <h2 className="coming-soon-text">Coming Soon...</h2>
      </div>

    </div>
  )
}

export default Woodshop_Pivot;